module.exports = __webpack_public_path__ + "static/media/chat_button_icon_active.78f1c87a.svg";